function AddComment({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 2C20 0.9 19.1 0 18 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H16L20 20V2ZM18 15.17L16.83 14H2V2H18V15.17ZM11 3H9V7H5V9H9V13H11V9H15V7H11V3Z" fill=${`"${col}"`}/>
    </svg>

  `;

  return baseXml;
}

export default AddComment;
